/**
 * Pure comparison extracted for unit-testability, mirroring
 * `getPersonaMenuOrigins.ts`'s precedent of pulling popover-adjacent logic
 * out of the component.
 *
 * The explicit `latestVersion !== undefined` guard is load-bearing, not
 * boilerplate: if `releaseNotes` is ever empty, `latestVersion` is
 * `undefined` and `lastSeenVersion` (key absent) is `null`.
 * `undefined !== null` is `true`, so the naive one-liner
 * `latestVersion !== lastSeenVersion` would report "unread" when there is
 * nothing new to show — caught in Swarm review (TypeScript Critic, WNB-3)
 * before this was written.
 */
export const isWhatsNewUnread = (
  latestVersion: string | undefined,
  lastSeenVersion: string | null,
): boolean => latestVersion !== undefined && latestVersion !== lastSeenVersion;
